import { createAsyncThunk } from '@reduxjs/toolkit';
import { PostClientErrorReport } from '../../../models/ClientErrors/PostClientErrorReport';

export const reportClientError = createAsyncThunk(
    'clientErrors/reportClientError',
    async (payload: PostClientErrorReport, dispatch: any) => {
        try {
            const axios = dispatch.getState().core.axios;
            await axios.post('/api/ClientErrorReports', payload);
        } catch {
            // Reporting must never throw or itself trigger another report.
        }
        return null;
    }
);
